import { render, staticRenderFns } from "./ProjectVacancies.vue?vue&type=template&id=83b23066&scoped=true"
import script from "./ProjectVacancies.vue?vue&type=script&lang=js"
export * from "./ProjectVacancies.vue?vue&type=script&lang=js"
import style0 from "./ProjectVacancies.vue?vue&type=style&index=0&id=83b23066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b23066",
  null
  
)

export default component.exports